import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LegFiJwtService } from 'app/services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from 'app/services/auth/jwt-legfi-claims.model';
import { FilterContainerComponent } from '../filter-container/filter-container.component';
import { UnifiedBankAccount } from '../../../../../models/entities/unified-bank-account';
import { SelectionModel } from '@angular/cdk/collections';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { GrowlerService } from '../../../../../services/growler.service';

@UntilDestroy()
@Component({
    selector: 'report-filter-bank-account-selector',
    templateUrl: './bank-account-selector.component.html',
    styleUrls: ['./bank-account-selector.component.scss'],
})
export class BankAccountSelectorComponent implements OnInit
{
    @Input() container: FilterContainerComponent;
    @Input() filters: { bankAccountIds: number[] } = null;
    @Input() label = 'Filter Deposit Account';
    @Input() placeholder = 'All Accounts';
    @Input() alliance = false;
    @Input() multiple = true;
    @Output() selectionChanged: EventEmitter<void> = new EventEmitter<void>();

    jwt: JwtLegFiClaims;
    selection: SelectionModel<UnifiedBankAccount> = new SelectionModel<UnifiedBankAccount>(true);
    bankAccounts: UnifiedBankAccount[] = [];

    constructor(
            private _bankAccountsService: BankAccountsService,
            private _growler: GrowlerService,
    ) {
    }

    ngOnInit() {
        this.container.register(this);
        this.jwt = LegFiJwtService.read();
        this.filters = {
            bankAccountIds: [],
        };
        this._bankAccountsService.getOrgBankAccounts(null).pipe(untilDestroyed(this)).subscribe(
                (unifiedBankAccounts: UnifiedBankAccount[]) => {
                    this.bankAccounts = unifiedBankAccounts.filter((acct) => {
                        if (this.alliance) {
                            return acct.isAllianceAccount;
                        }
                        return true;
                    });
                    this.container.notifyReady(this);
                },
                () => {
                    this._growler.error(
                            'Error Loading Bank Accounts',
                            'There was an error loading your organization\'s bank accounts. Please refresh the page to try again.',
                    );
                },
        );
    }

    toggleAccount(account) {
        if (this.multiple) {
            this.selection.toggle(account);
        } else {
            if (!this.selection.isSelected(account)) {
                this.selection.select(account);
            }
        }
        this.filters.bankAccountIds = this.selection.selected.map((bank) => bank.id);
        this.selectionChanged.emit();
    }
}
